export const DATE_FORMAT = "DD/MM/YYYY"
export const DATE_TIME_FORMAT = "DD/MM/YY HH:mm"
export const DATE_TIME_FORMAT_DASH = "DD-MM-YYYY HH:mm"